import {
  type PortfolioFilters,
  usePortfolioFilters,
} from 'components/technical/PortfolioFilterDrawer/UsePortfolioFilters';
// biome-ignore lint/nursery/noRestrictedImports: why bro
import { every, isEmpty, omitBy, pick } from 'lodash';

export function useSubAccountAssetFilters(filters: Partial<PortfolioFilters>): Partial<PortfolioFilters> {
  const { portfolioFilters } = usePortfolioFilters();
  const portfolioFilterKeys: (keyof PortfolioFilters)[] = ['subFundIds', 'accountIds', 'subAccountIds', 'assetIds'];
  const validPortfolioFilters = pick(filters, portfolioFilterKeys);

  const finalFilters = omitBy(validPortfolioFilters, isEmpty);
  const isEmptyFilters = every(finalFilters, isEmpty);

  return isEmptyFilters ? portfolioFilters : finalFilters;
}
